import { Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import { Button, Collapse, Container, Form, Group, NakedButton, Text, useMelioForm } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import { useState } from 'react';

export const SubscriptionCheckoutPromoCode = () => {
  const { formatMessage } = useMelioIntl();
  const [showPromoCodeInput, setShowPromoCodeInput] = useState<boolean>(false);
  const [promoCode, setPromoCode] = useState<string>('');

  const { registerField, formProps, resetField } = useMelioForm({
    onSubmit: ({ promocode }) => {
      if (promocode) {
        setPromoCode(promocode);
      }
    },
    defaultValues: { promocode: '' },
  });
  const togglePromoCodeInput = () => setShowPromoCodeInput((prev) => !prev);
  const removePromoCode = () => {
    setPromoCode('');
    resetField('promocode');
    setShowPromoCodeInput(true);
  };

  if (promoCode) {
    return (
      <Container>
        <Group justifyContent="space-between">
          <Tag size="md" borderRadius="full">
            <TagLabel>{promoCode}</TagLabel>
            <TagCloseButton onClick={removePromoCode} />
          </Tag>
          <Text color="success.main" textStyle="body3">
            -$20.00
          </Text>
        </Group>

        <Container paddingTop="xs">
          <Text color="neutral.darker" textStyle="body4">
            {formatMessage('activities.subscription.checkout.summary.promocode.applied.description')}
          </Text>
        </Container>
      </Container>
    );
  }

  return (
    <Container>
      <NakedButton
        label={formatMessage('activities.subscription.checkout.summary.promocode.label')}
        variant="secondary"
        onClick={togglePromoCodeInput}
      />

      <Collapse in={showPromoCodeInput}>
        <Form paddingTop="xs" columns={3} gap="s" {...formProps}>
          <Form.TextField
            colSpan={2}
            {...registerField('promocode')}
            aria-label={formatMessage('activities.subscription.checkout.summary.promocode.label')}
            size="small"
          />
          <Button
            label={formatMessage('activities.subscription.checkout.summary.promocode.submit')}
            onClick={formProps.onSubmit}
          />
        </Form>
      </Collapse>
    </Container>
  );
};
